// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button__Button___3bi60","success":"Button__success___jlUCc","error":"Button__error___1gfMk","primary":"Button__primary___3iRH1"};